import type { IdNumberFormutil, IdNumberProps } from 'components/forms/IdNumber';
import type { GenderEnum } from 'types/customer';
import type { FamilyInfoFormutil, FamilyInfoProps } from '../FamilyInfo';
import type { BirthdayFormutil } from './components/Birthday';
import type { NonSSNPersonalInfoFormutil, NonSSNProps } from './NonSSN';
import { SSNPersonalInfoFormutil, SSNProps } from './SSN';

export interface BasePersonalInfoFormutil extends BirthdayFormutil, IdNumberFormutil, FamilyInfoFormutil {
    gender: GenderEnum;
    country: string;
    born_country: string;
}

export interface BasePersonalInfoProps {
    disabled?: boolean;
    /** 开户流程使用，仅展示对应类型字段。esop、upgrade、update、modify无需此参数 */
    type?: 'baseinfo' | 'baseinfo2';
    idNumberProps: IdNumberProps;
    familyInfoProps?: FamilyInfoProps;
}

export type PersonalInfoFormutil = SSNPersonalInfoFormutil & NonSSNPersonalInfoFormutil;

export interface PersonalInfoProps extends SSNProps, NonSSNProps {
    isSSN: boolean;
}
